import React, { useState } from 'react'
import { Button } from 'reactstrap'
import CarInspectionDetail from '../../Cars/CarDetailNew/InspectionTab/CarInspectionDetail'
import AddInspectionModal from './AddInspectionModal'
import './InspectionTab.css'

const InspectionTab = (props) => {
    const [addInspectionModalOpen, setAddInspectionModalOpen] = useState(false)
    const incident = props.incident
    const carId = incident?.car?.id
    const rentalId = incident?.rental?.id

    return <div className="inspection-tab-container">
        <div className="incident-overview-header">
            <div className="incident-overview-header__titles">
                <h3 className="incident-overview-header__title">Inspection</h3>
                <p className="incident-overview-header__subtitle">Vehicle inspection details captured for this incident.</p>
            </div>
        </div>
        {props.id ?
            <CarInspectionDetail id={props.id} viewType={props.viewType} />
            : <div className="inspection-tab-empty-state-wrap">
                <div className="inspection-tab-empty-state">
                    <span className="inspection-tab-empty-state__icon">
                        <i className="fa fa-cogs" aria-hidden="true" />
                    </span>
                    <h3 className="inspection-tab-empty-state__title mb-0">No Inspection Yet</h3>
                    <p className="inspection-tab-empty-state__description">
                        Attach an existing car inspection to keep this incident complete.
                    </p>
                    {incident?.id && <Button
                        color="primary"
                        size="sm"
                        className="inspection-tab-empty-state__button"
                        onClick={() => setAddInspectionModalOpen(true)}
                        disabled={!carId}
                    >
                        <i className="fa fa-plus" aria-hidden="true" />
                        <span>Add Inspection</span>
                    </Button>}
                </div>
                {addInspectionModalOpen && carId &&
                    <AddInspectionModal
                        isOpen={addInspectionModalOpen}
                        handleClose={() => setAddInspectionModalOpen(false)}
                        incidentId={incident.id}
                        carId={carId}
                        rentalId={rentalId}
                        refetchQuery={props.refetchQuery}
                    />
                }
            </div>
        }
    </div>
}

export default InspectionTab
